import { render, staticRenderFns } from "./RadioBox1.vue?vue&type=template&id=8c9dc042&scoped=true"
import script from "./RadioBox1.vue?vue&type=script&lang=js"
export * from "./RadioBox1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9dc042",
  null
  
)

export default component.exports